const { default: CommonServices } = require("./common/common");

class InformationManagementService extends CommonServices {
  constructor() {
    super("/information");
  }
}

const informationManagementService = new InformationManagementService();
export default informationManagementService;
